import {
  getYmaps403BaseMessage,
  getYmapsRefererHint,
} from "./ymapsRefererHint";

export function getMapLoadErrorMessage(error) {
  const code = error?.message;
  if (code === "NO_API_KEY") {
    return "Не настроен API-ключ карт";
  }
  if (code === "SCRIPT_LOAD_FAILED" || code === "YMAPS3_MISSING") {
    return getYmaps403BaseMessage() + getYmapsRefererHint();
  }
  if (code === "YMAPS3_READY_FAILED") {
    return (
      "Ключ карт отклонён или ограничения ещё не применились (до 1 часа). " +
      "Проверьте ключ и Referer в кабинете Яндекса." +
      getYmapsRefererHint()
    );
  }
  return "Не удалось загрузить карту";
}
